import axios, { parseCursor } from '@/base/api/axios'
import { toFormData, underscorizeKeys } from '@/utils/utils'

export default {

  async create (offer) {
    return (await axios.post('/api/offers/', await toFormData(offer))).data
  },

  async get (offerId) {
    return (await axios.get(`/api/offers/${offerId}/`)).data
  },

  async list (filter) {
    const params = filter || {}
    const response = (await axios.get('/api/offers/', { params: underscorizeKeys(params) })).data
    return {
      ...response,
      next: parseCursor(response.next),
      results: response.results,
    }
  },

  async save (offer) {
    return (await axios.patch(`/api/offers/${offer.id}/`, await toFormData(offer))).data
  },

  async archive (offerId) {
    return (await axios.post(`/api/offers/${offerId}/archive/`)).data
  },

  async conversation (offerId) {
    return (await axios.get(`/api/offers/${offerId}/conversation/`)).data
  },

}
